import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-profile-password-factor',
  templateUrl: './password-factor.component.html',
  styleUrl: './password-factor.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordFactorComponent {
  @Input({ required: true }) passwordForm!: FormGroup;
  @Input() showPasswordDialog = false;
  @Input() changingPassword = false;

  @Output() openPasswordDialog = new EventEmitter<void>();
  @Output() closePasswordDialog = new EventEmitter<void>();
  @Output() submitPasswordChange = new EventEmitter<void>();
}
